const DateFormats = {
    DATE_TIME_FORMAT_12H : 'YYYY-MM-DDThh:mm',
    DATE_TIME_FORMAT_24H : 'YYYY-MM-DDTHH:mm'
};
exports.DateFormats = DateFormats;